module.exports = require("./es-BZ.d.ts");